export default {
    section: 'Registered Agent',
    name: 'entity-formation-registered-agent',
    questionWidth: 4,
    items: [
        {
            type: 'inline',
            text: 'Contact Name',
            items: [
                {
                    type: 'text-field',
                    name: 'entity-formation-registered-agent-first-name',
                    width: 3,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'entity-formation-registered-agent-last-name',
                    width: 3,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Contact Phone',
            name: 'entity-formation-registered-agent-phone',
            width: 3,
            props: {
                label: 'Phone',
                format: 'phone'
            }
        },
        {
            type: 'text-field',
            text: 'Legal Address',
            name: 'entity-formation-registered-agent-address-street',
            props: {
                label: 'Address'
            },
            subItems: [
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            name: 'entity-formation-registered-agent-address-city',
                            width: 3,
                            props: {
                                label: 'City'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'entity-formation-registered-agent-address-state',
                            width: 1,
                            props: {
                                label: 'State',
                                items: [
                                    // TODO: Swap States
                                    {
                                        text: 'swap-states',
                                        value: 'swap-states'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'entity-formation-registered-agent-address-zip',
                            width: 2,
                            props: {
                                label: 'Zip'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/entity-new/valuation-data/registered-agent.js